import { ref } from "firebase/storage";
import { storage } from "./FirebaseConfig"; // Adjust the path based on your project structure

/**
 * Extracts the Firebase Storage reference from a given file URL.
 * This function removes unnecessary query parameters and returns a valid storage reference.
 */
export const getStorageRefFromUrl = (fileUrl) => {
    try {
        const baseUrl = "https://firebasestorage.googleapis.com/v0/b/";
        if (!fileUrl.includes(baseUrl)) return null;

        const pathStart = fileUrl.indexOf("/o/") + 3;
        const pathEnd = fileUrl.indexOf("?alt=media");
        const filePath = decodeURIComponent(fileUrl.substring(pathStart, pathEnd));

        return ref(storage, filePath);
    } catch (error) {
        console.error("❌ Error extracting file path from URL:", error);
        return null;
    }
};
